export default __webpack_public_path__ + "static/media/1758.6e0a6785.png";